import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty, isEqual } from 'lodash';
import { Trans } from '@lingui/macro';
import SitesLinkByIP, { MemoizedSitesList } from '../SitesLinkByIP';
import { NgpLabelValue } from '../../../form/NgpLabelValue';

const DeviceSitesLink = ({ deviceIpAddress, sites }) => {
    if (!isEmpty(sites)) {
        return <MemoizedSitesList sites={sites} />;
    }

    return <SitesLinkByIP ip={deviceIpAddress} />;
};

const DeviceSites = ({ deviceIpAddress, sites }) => {
    return (
        <NgpLabelValue
            dataLabel={<Trans>Sites</Trans>}
            dataValue={<DeviceSitesLink deviceIpAddress={deviceIpAddress} sites={sites} />}
        />
    );
};

DeviceSites.propTypes = {
    deviceIpAddress: PropTypes.string.isRequired,
    sites: PropTypes.array,
};

DeviceSites.defaultProps = {
    sites: [],
};

export default React.memo(DeviceSites, (oldProps, newProps) =>
    isEqual(oldProps.deviceIpAddress, newProps.deviceIpAddress)
);
